import { useInfiniteQuery } from 'react-query';
import {
  getSceneOriginalEpisodeParagraphs,
  type SceneOriginalEpisodeParagraphsParams
} from '../../services/sceneService';

export function useGetSceneEpisodeParagraphs(
  sceneId: string,
  episodeId: string,
  params?: SceneOriginalEpisodeParagraphsParams,
  options?: { enabled?: boolean }
) {
  const enabled = options?.enabled ?? true;
  const baseParams = params ?? {};

  return useInfiniteQuery(
    ['sceneEpisodeParagraphs', sceneId, episodeId, baseParams],
    ({ pageParam }: { pageParam?: { cursor?: number; direction?: 'after' | 'before' } }) =>
      getSceneOriginalEpisodeParagraphs({
        sceneId,
        episodeId,
        params: {
          ...baseParams,
          cursor: pageParam?.cursor ?? baseParams.cursor,
          direction: pageParam?.direction ?? baseParams.direction
        }
      }),
    {
      enabled: !!sceneId && !!episodeId && enabled,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => {
        const { hasMore, nextCursor } = lastPage.meta.pagination;
        if (!hasMore || nextCursor == null) return undefined;
        return { cursor: nextCursor, direction: 'after' as const };
      },
      getPreviousPageParam: (firstPage) => {
        const { hasMore, prevCursor } = firstPage.meta.pagination;
        if (!hasMore || prevCursor == null) return undefined;
        return { cursor: prevCursor, direction: 'before' as const };
      }
    }
  );
}
